module.exports = __webpack_public_path__ + "img/male-symbol.02bb1ba8.png";